<template>
    <div class="knob">
        <svg viewBox="0 0 100 100" class="knob-svg">
            <circle
                cx="50"
                cy="50"
                r="45"
                stroke="#e0e0e0"
                stroke-width="10"
                fill="none"
            />
            <circle
                cx="50"
                cy="50"
                r="45"
                stroke="#4caf50"
                stroke-width="10"
                fill="none"
                stroke-dasharray="283"
                :stroke-dashoffset="offset"
                :style="{ transition: 'stroke-dashoffset 0.5s ease', transform: 'rotate(-90deg)', transformOrigin: '50% 50%' }"
            />
            <!-- stroke dasharray 2 * π * r -->
        </svg>
        <div class="progress-text">{{ currentStep }}/{{ totalSteps }}</div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        totalSteps: {
            type: Number,
            required: true
        }
    },
    computed: {
        percentage() {
            return (this.currentStep / this.totalSteps) * 100;
        },
        offset() {
            const radius = 45; // Radius of the circle
            const circumference = 2 * Math.PI * radius; // Circumference of the circle
            return circumference - (this.percentage / 100) * circumference; // Calculate the offset
        }
    }
}
</script>

<style scoped>
.knob {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 25vw;
    height: 25vw;
    max-width: 50px;
    max-height: 50px;
}

.knob-svg {
  width: 100%;
  height: 100%;
}

.progress-text {
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@media screen and (max-width: 39.9375em) {
    .knob {
        width: 20vw;
        height: 20vw;
        max-width: 32px;
        max-height: 32px;
    }

    .progress-text {
        font-size: 10px;
    }
}
</style>